module.exports = __webpack_public_path__ + "05_veryshort_brown.51d61b37.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/05_veryshort_brown.png
// module id = mxj4
// module chunks = 0